








import Vue from 'vue';
import NewContainer from '@/containers/cover-letters/new.vue';

export default Vue.extend({
  // NOTE: DO NOT reset state of CoverLettersStore
  components: {
    NewContainer,
  },
});
